import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LocationSearchContainer from '../../../../containers/LocationSearchContainer';
import Header from '../Header';
import CuisinePageHero from '../../../../components/CuisinePageHero';
import i18n from '../../../../utils/i18n';
import { urlWithLocale } from '../../../../utils/locale';

class Hero extends React.Component {
  validateProps({ headerComponents, heading, description, breadcrumb, image }) {
    return (
      headerComponents &&
      typeof heading === 'string' &&
      typeof description === 'string' &&
      typeof breadcrumb === 'string' &&
      typeof image === 'string'
    );
  }

  componentDidMount() {
    const { header: headerComponents, heading, description, breadcrumb, image } = this.props;

    if (
      !this.validateProps({
        headerComponents,
        heading,
        description,
        breadcrumb,
        image,
      })
    ) {
      throw new Error('Incorrect prop-types for Storyblok Hero component');
    }
  }

  render() {
    const {
      landingPageName,
      isPostcodeSearch,
      header: headerComponents,
      heading,
      description,
      breadcrumb,
      image,
      currentCountry,
      locale,
    } = this.props;

    const locationSearch = (
      <LocationSearchContainer
        caption={i18n.gettext(
          `landingPage.cuisine.locationSearch.input.${
            isPostcodeSearch ? 'postcode' : 'formattedAddress'
          }.label(%(cuisine)s)`,
          { cuisine: breadcrumb },
        )}
        searchType="restaurants"
        searchFilter={{
          tags: landingPageName.toLowerCase(),
        }}
        trackingPage={`${landingPageName} Landing Page`}
        isModal={false}
      />
    );

    const headerComponent =
      headerComponents && headerComponents[0] ? <Header {...headerComponents[0].props} /> : null;

    const localisedHomePath = urlWithLocale(currentCountry, '/', locale);
    const localisedCuisinePath = `${localisedHomePath}cuisines`;

    const breadcrumbs = [
      {
        href: localisedHomePath,
        label: i18n.gettext('landingPage.cuisine.hero.breadcrumbs.home'),
      },
      {
        href: localisedCuisinePath,
        label: i18n.gettext('landingPage.cuisine.hero.breadcrumbs.cuisine'),
      },
      {
        label: breadcrumb,
      },
    ];

    return (
      <CuisinePageHero
        header={headerComponent}
        heading={heading}
        description={description}
        locationSearch={locationSearch}
        image={image}
        breadcrumbs={breadcrumbs}
      />
    );
  }
}

Hero.propTypes = {
  landingPageName: PropTypes.string.isRequired,
  isPostcodeSearch: PropTypes.bool.isRequired,
  header: PropTypes.arrayOf(
    PropTypes.shape({
      ...Header.propTypes,
    }),
  ),
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  breadcrumb: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  currentCountry: PropTypes.shape({
    postcodeSearch: PropTypes.bool.isRequired,
  }).isRequired,
  locale: PropTypes.string.isRequired,
};

Hero.defaultProps = {
  header: null,
};

const mapStateToProps = (state) => {
  const { country: currentCountry, locale } = state.request;
  const { postcodeSearch: isPostcodeSearch } = currentCountry;
  const { name: landingPageName } = state.landingPage;

  return {
    landingPageName,
    isPostcodeSearch,
    currentCountry,
    locale,
  };
};

export default connect(mapStateToProps)(Hero);
